import composition from "rfuncs/functions/composition"
import base64safe from "workflow/utils/base64safe"
import json from "workflow/utils/json"

const dumps = composition(json.dumps, base64safe.dumps)
const loads = composition(base64safe.loads, json.loads)

export default { loads, dumps }
